<mat-form-field appearance="outline">
  <mat-label>Land</mat-label>
  <div>
    <input
      type="text"
      #selectInput
      [formControl]="formItem"
      [matAutocomplete]="auto"
      matInput
      (input)="onSearchChange($event)"
      placeholder="Vælg"
      class="flag" />
    </div>
    <mat-autocomplete #auto="matAutocomplete" hideSingleSelectionIndicator="true" [displayWith]="displayFn" okCustomDropDownArrowDirective>
      @for (item of filteredItems$ | async; track item) {
        <mat-option [value]="item.code" (onSelectionChange)="onItemSelected(item, $event)">
          <span class="flag">
            {{ item.flag }}
          </span>
          {{ item.name }} +{{ item.code }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
